module.exports = __webpack_public_path__ + "static/img/on8.8945a55c.png";